import React, { useState } from 'react';
import Heading from '../../components/common/Heading/Heading';
import DynamicTableAnt from '../../hooks/DynamicTableAnt';
import { App, Button, Popconfirm, Popover, Space } from 'antd';
import { MdDelete, MdModeEditOutline } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import { queryKeys } from '../../services/react-query/queryKeys';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { deleteItems, getItems } from '../../network/Item';

const Items = ({ t }) => {
  const client = useQueryClient();
  const [searchText, setSearchText] = useState('');
  const navigate = useNavigate();
  const { message } = App.useApp();
  const handleRemove = useMutation(
    // (id) => deletePatient(id),
    {
      mutationFn: (id) => deleteItems(id),
      onSuccess: (data) => {
        console.log(data, 'data');
        if (data?.message?.status === 500) {
          message.error(data?.message?.message);
          return false;
        }
        message.success('Record successfully deleted!');
        //  message.success('تم الحذف بنجاح');
        client.invalidateQueries({ queryKey: [queryKeys.getItems] });
      },
      onError: () => {
        message.error('حدث خطأ ما');
      },
    }
  );
  const { data, isError, error, isLoading } = useQuery({
    queryKey: [queryKeys.getItems],
    queryFn: () => getItems(),
    keepPreviousData: true,
  });
  const columns = [
    {
      title: t.itemName,
      dataIndex: 'item_name',
      filteredValue: [searchText],
      onFilter: (value, record) => {
        const name = String(record.item_name).toLowerCase();
        const searchValue = value.toLowerCase();
        // console.log(record);
        return name.includes(searchValue);
      },
      render: (text, record) => {
        return (
          <span
            style={{ cursor: 'pointer' }}
            className="text-primary"
            onClick={() => {
              navigate(`/item/${record.name}`)
            }}
          >
            {text}
          </span>
        );
      },
    },
    {
      title: t.type,
      dataIndex: 'item_group',
    },
    // {
    //   title: t.shelfLifeInDays,
    //   dataIndex: 'shelf_life_in_days',
    // },
    {
      title: t.price,
      dataIndex: 'rate',
    },
    {
      title: t.unitofMeasure,
      dataIndex: 'stock_uom',
    },
    {
      title: t.action,
      dataIndex: 'action',
      key: 'action',
      render: (text, record) => {
        // console.log('record:', record);
        return (
          <Space>
            <Popover
              placement="top"
              title={t.edit}
              // onClick={() =>
              //   navigate(`/patients/${record.custom_file_number}`)
              // }
            >
              <Button
                size="small"
                type="primary"
                onClick={() => navigate(`/item/${record.name}`)}
              >
                <MdModeEditOutline />
              </Button>
            </Popover>
            <Popconfirm
              title={t.DeletetheItem}
              description={t.areYouSure}
              onConfirm={() => handleRemove.mutate(record?.name)}
              // onCancel={cancel}
              okText={t.yes}
              cancelText={t.no}
            >
              <Button size="small" type="primary" danger>
                <MdDelete />
              </Button>
            </Popconfirm>
          </Space>
        );
      },
    },
  ];
  const dataTable = data?.message?.items?.map((item, index) => ({
    key: index,
    ...item,
  }));

  if (isError) {
    console.log('error:', error);
    return message.error(error.message);
  }
  return (
    <div className="items">
      <Heading title={t.Healthcare} subTitle={t.items} path="/" />
      <DynamicTableAnt
        columns={columns}
        data={dataTable}
        loading={isLoading}
        setSearchText={setSearchText}
        titleBtn={t.addNewItem}
        Placeholder={t.searchItems}
        pathBtn="/item/add"
      />
    </div>
  );
};

export default Items;
